'use client';

import MerchantsHero from '@/sections/merchantsHero/MerchantsHero';
import MerchantsFeatures from '@/sections/merchantsFeatures/MerchantsFeatures';
import MerchantsImpact from '@/sections/merchantsImpact/MerchantsImpact';
import MerchantsBenefits from '@/sections/merchantsBenefits/MerchantsBenefits';
import MerchantsFitsYourStore from '@/sections/merchantsFitsYourStore/MerchantsFitsYourStore';
import MerchantsTravellersDestination from '@/sections/merchantsTravellersDestination/MerchantsTravellersDestination';
import MerchantsTestimonial from '@/sections/merchantsTestimonial/MerchantsTestimonial';
import { useEffect, useState, Suspense } from 'react';
import { useSearchParams, usePathname } from 'next/navigation';

function MerchantsContent() {
  const [selectedMarket, setSelectedMarket] = useState<'es' | 'it'>('es');
  const [isClient, setIsClient] = useState(false);

  const searchParams = useSearchParams();
  const pathname = usePathname();

  useEffect(() => {
    // Mark as client-side rendered
    setIsClient(true);

    const marketParam = searchParams.get('market');

    if (marketParam === 'it') {
      setSelectedMarket('it');
    } else if (marketParam === 'es') {
      setSelectedMarket('es');
    } else {
      // If no URL parameter, check the country cookie
      const cookies = document.cookie.split(';');
      const countryCookie = cookies.find((cookie) => cookie.trim().startsWith('user-country='));
      const country = countryCookie ? countryCookie.split('=')[1].trim() : '';

      setSelectedMarket(country === 'IT' ? 'it' : 'es');
    }
  }, [searchParams, pathname]);

  // Don't render until client-side to avoid hydration mismatch
  if (!isClient) {
    return null;
  }

  return (
    <main>
      <MerchantsHero selectedMarket={selectedMarket} />
      <MerchantsFeatures selectedMarket={selectedMarket} />
      <MerchantsImpact />
      <MerchantsBenefits selectedMarket={selectedMarket} />
      <MerchantsFitsYourStore />
      <MerchantsTestimonial />
      <MerchantsTravellersDestination selectedMarket={selectedMarket} />
    </main>
  );
}

export default function Merchants() {
  return (
    <Suspense fallback={<div>Loading...</div>}>
      <MerchantsContent />
    </Suspense>
  );
}
